/**
 * Report interval options used across the application
 * Values represent the number of months for each reporting period
 * These values are used in conjunction with startDate and hoursPerYear/cpdHours
 * to calculate CPD requirements and deadlines
 */
export const REPORT_INTERVAL_OPTIONS = [
    { value: 1, text: 'Monthly' },
    { value: 3, text: 'Quarterly' },
    { value: 12, text: 'Annually' },
    { value: 24, text: 'Biennium - 2 years' },
    { value: 36, text: 'Triennial - 3 years'},
    { value: 48, text: 'Quadrennial - 4 years'},
    { value: 60, text: 'Quinquennial - 5 years'}
];
